import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.333 4.667H17V6h-4.667zM10.333 14H17v1.333h-6.667zM15 9.333h2v1.334h-2zM9.667 6.667a1.333 1.333 0 1 0-1.155-2H3V6h5.512c.23.399.661.667 1.155.667M12.333 11.333a1.333 1.333 0 1 0-1.155-2H3v1.333h8.179c.23.399.66.667 1.154.667M7.667 16a1.333 1.333 0 1 0-1.155-2H3v1.334h3.512c.23.398.661.666 1.155.666"
    }, null, -1)
  ])))
}
export default { render: render }